<template>
  <div class="w-100 h-100 main-container">
    <div class="w-100 h-100 main-container" v-if="motivationSent">
      <div class="counter-container">
        <b-container class="mw-100 mt-1 mb-1">
          <b-row align-v="center">
            <b-col cols="auto" v-if="realTime">
              <b-container class="mw-100">
                <b-row align-v="center" v-if="realTime">
                  <b-col cols="auto">
                    <calendar-picker v-model="myDate" :fields="['year', 'month', 'day', 'weekdayShort']"></calendar-picker>
                  </b-col>

                  <b-col cols="auto">
                    <calendar-picker v-model="myDate" :fields="isSafari ? ['hour', 'minute'] : ['hour', 'minute', 'second']"></calendar-picker>
                  </b-col>
                </b-row>
              </b-container>
            </b-col>

            <b-col cols="auto" v-if="realTime && !isSafari">
              <b-container>
                <b-row align-v="center">
                  <h5 class="mb-0 ml-3"><b>{{$t('message.nexRefresh')}}:</b></h5>
                  <number-flip :value="refreshCountDown" :color="'rgba(254,0,12,0.85)'"></number-flip>
                </b-row>
              </b-container>
            </b-col>

            <b-col cols="auto" sm="12" md="auto" lg="auto" xl="auto" class="d-flex flex-row" v-if="!realTime">
              <b-container class="mw-100">
                <b-row>
                  <b-col sm="auto" md="auto" lg="auto" xl="auto" cols="auto" class="mb-2">
                    <b-row>
                      <calendar-picker v-model="myDate" :fields="['year']"></calendar-picker>
                      <span class="d-flex flex-column mr-2">
                      <font-awesome-icon icon="angle-up"
                                         class="hover-enabled h-c-blue"
                                         @click="changeDate('myDate', 'years', 1)"
                                         v-if="checkIfCouldBeMore('myDate', 'years', 1)">
                      </font-awesome-icon>

                      <font-awesome-icon icon="angle-double-up"
                                         :class="`${reachedTop('myDate')}`"
                                         @click="changeDate('myDate', 'years', 1, true)"
                                         v-else />

                      <font-awesome-icon icon="angle-down"
                                         class="hover-enabled h-c-blue"
                                         @click="changeDate('myDate', 'years', -1)" />
                    </span>
                    </b-row>
                  </b-col>

                  <b-col sm="auto" md="auto" lg="auto" xl="auto" cols="auto" class="mb-2">
                    <b-row>
                      <calendar-picker v-model="myDate" :fields="['month']"></calendar-picker>
                      <span class="d-flex flex-column mr-2">
                      <font-awesome-icon size="sm" icon="angle-up"
                                         class="hover-enabled h-c-blue"
                                         @click="changeDate('myDate', 'months', 1)"
                                         v-if="checkIfCouldBeMore('myDate', 'months', 1)">
                      </font-awesome-icon>

                      <font-awesome-icon size="sm" icon="angle-double-up"
                                         :class="`${reachedTop('myDate')}`"
                                         @click="changeDate('myDate', 'months', 1, true)"
                                         v-else>
                      </font-awesome-icon>

                      <font-awesome-icon size="sm" icon="angle-down"
                                         class="hover-enabled h-c-blue"
                                         @click="changeDate('myDate', 'months', -1)">
                      </font-awesome-icon>
                    </span>
                    </b-row>
                  </b-col>

                  <b-col sm="12" md="auto" lg="auto" xl="auto" cols="auto" class="mb-2">
                    <b-row>
                      <calendar-picker v-model="myDate" :fields="['day']"></calendar-picker>
                      <calendar-picker v-model="myDate" :fields="['weekdayShort']" :width="lang === 'it' ? 65 : 70"></calendar-picker>
                      <span class="d-flex flex-column mr-4 mr-sm-2 mr-md-2 mr-lg-2 mr-xl-2">
                      <font-awesome-icon size="sm" icon="angle-up"
                                         class="hover-enabled h-c-blue"
                                         @click="changeDate('myDate', 'days', 1)"
                                         v-if="checkIfCouldBeMore('myDate', 'days', 1)">
                      </font-awesome-icon>

                      <font-awesome-icon size="sm" icon="angle-double-up"
                                         :class="`${reachedTop('myDate')}`"
                                         @click="changeDate('myDate', 'days', 1, true)"
                                         v-else>
                      </font-awesome-icon>

                      <font-awesome-icon size="sm" icon="angle-down"
                                         class="hover-enabled h-c-blue"
                                         @click="changeDate('myDate', 'days', -1)">
                      </font-awesome-icon>
                    </span>
                    </b-row>
                  </b-col>
                </b-row>
              </b-container>
            </b-col>

            <b-col cols="auto" class="d-flex flex-row" v-if="!realTime">
              <b-container>
                <b-row class="mb-2">
                  <calendar-picker v-model="myDate" :fields="['hour', 'minutes']"></calendar-picker>
                  <span class="d-flex flex-column mr-2">
                      <font-awesome-icon size="sm" icon="angle-up"
                                         class="hover-enabled h-c-blue"
                                         @click="changeDate('myDate', 'hours', 1)"
                                         v-if="checkIfCouldBeMore('myDate', 'hours', 1)">
                      </font-awesome-icon>

                      <font-awesome-icon size="sm" icon="angle-double-up"
                                         :class="`${reachedTop('myDate')}`"
                                         @click="changeDate('myDate', 'hours', 1, true)"
                                         v-else>
                      </font-awesome-icon>

                      <font-awesome-icon size="sm" icon="angle-down"
                                         class="hover-enabled h-c-blue"
                                         @click="changeDate('myDate', 'hours', -1)">
                      </font-awesome-icon>
               </span>
                </b-row>
              </b-container>
            </b-col>

            <b-col class="d-flex flex-row" v-if="!realTime"
                   cols="12" sm="12" md="12" lg="8" xl="6">
              <div class="w-100 h-100 d-flex mb-4 mt-1 ml-2 mr-2">
                <slider v-model="hourRangeSelector"
                        class="d-flex flex-grow-1"
                        :marks="!isMobile"
                        :data="getSlideData()"
                        :tooltip-placement="['bottom']"
                        useKeyboard
                        adsorb>
                </slider>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </div>

      <div class="all-content">
        <div class="view-container" :style="isMobile ? 'flex-flow: column wrap' : 'flex-flow: row wrap'">
          <div class="map-container" :style="isMobile ? 'order: 3' : 'order: 2'">
            <div class="my-map">
              <Map :apiUrl="url"
                   :authToken="token"
                   ref="staticMap"
                   :vehicleId="vehicleSelected"
                   :driverId="driverSelected"
                   :tsStart="(filterStart / 1000) + ''"
                   :tsEnd="(filterEnd / 1000) + ''"
                   :usecase="realTime ? 'realtime' : 'history'"
                   @click-position="clickPosition"
                   @loaded-positions="loadedHistoryPosition"
                   @alert-error="mapError"
                   :screen-shot="false">
              </Map>
            </div>
          </div>

          <div class="my-sidebar-container b-c-s-white c-white" :style="isMobile ? 'order: 2' : 'order: 3'">
            <div class="my-sidebar">
              <b-container class="mw-100 h-100">
                <b-row align-h="center">
                  <div @click="shown = !shown"
                       class="fa fa-bars w-100 p-sm-2 p-2 p-md-2 p-lg-2 p-xl-3 d-flex flex-row justify-content-center hover-enabled b-c-ls-gray">
                  </div>
                </b-row>

                <b-row>
                  <b-col>
                    <transition name="slide-left">
                      <b-container v-show="shown" class="mw-100 m-0 p-0">
                        <b-row align-h="center" class="mt-3 mb-2">
                          <b-col cols="auto">
                            <switch-button v-model="realTime"
                                           :color="{checked: '#249a80', unchecked: '#4285f4'}"
                                           :sync="true"
                                           :width="170"
                                           :height="32"
                                           :font-size="15.5"
                                           :speed="500"
                                           :labels="true">
                              <template slot="checked">
                                {{$t('message.realTime')}}
                              </template>
                              <template slot="unchecked">
                                {{$t('message.travel')}}
                              </template>
                            </switch-button>
                          </b-col>
                        </b-row>

                        <b-row>
                          <transition name="slide-left">
                            <b-col>
                              <b-card class="m-0 p-0 border-0 c-black b-c-s-white" no-body>
                                <b-container class="mw-100 m-0 p-0">
                                  <b-row :class="showContent(shownVehicle)">
                                    <b-col @click="shownVehicle = !shownVehicle" :class="`{{showContent(shownVehicle)}} p-0 hover-enabled`">
                                      <a class="vsm-link p-2">
                                        <i :class="shownVehicle ? 'fa fa-angle-down mb-3 mt-3 m-2' : 'fa fa-angle-left mb-3 mt-3 m-2'"></i>
                                        <span class="vsm-title">{{$t('message.filterBy')}} {{$tc('message.numberPlate', 1).toLowerCase()}}</span>
                                      </a>
                                    </b-col>
                                  </b-row>

                                  <b-row>
                                    <b-collapse class="w-100 b-c-s-white" id="collapse-vehicle" v-model="shownVehicle">
                                      <b-container class="my-max-width">
                                        <b-row align-h="center" align-v="center" class="text-center mt-2 pl-2 pr-2">
                                          <b-form-group label-for="input-vehicle" class="flex-grow-1 mb-1">
                                            <model-list-select id="input-vehicle"
                                                               option-text="text"
                                                               option-value="id"
                                                               :customText="getVehicleOption"
                                                               :placeholder="allVehicles && allVehicles.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                                               v-model="vehicleSelected"
                                                               :list="allVehicles">
                                            </model-list-select>
                                          </b-form-group>
                                        </b-row>

                                        <b-row align-h="center" align-v="center" v-if="!realTime" class="mb-2">
                                          <b-col cols="auto">
                                            <b-button @click="showReportModalOrDownload()" class="b-c-green"
                                                      :disabled="vehicleSelected === '' || !vehicleSelected">
                                              {{$tc('message.report', 1)}}
                                            </b-button>
                                          </b-col>
                                        </b-row>
                                      </b-container>
                                    </b-collapse>
                                  </b-row>
                                </b-container>
                              </b-card>
                            </b-col>
                          </transition>
                        </b-row>

                        <b-row>
                          <transition name="slide-left">
                            <b-col>
                              <b-card class="m-0 p-0 border-0 c-black b-c-s-white" no-body>
                                <b-container class="mw-100 m-0 p-0">
                                  <b-row :class="showContent(shownAppointee)">
                                    <b-col @click="shownAppointee = !shownAppointee" :class="`{{showContent(shownAppointee)}} p-0 hover-enabled`">
                                      <a class="vsm-link p-2">
                                        <i :class="shownAppointee ? 'fa fa-angle-down mb-3 mt-3 m-2' : 'fa fa-angle-left mb-3 mt-3 m-2'"></i>
                                        <span class="vsm-title">{{$t('message.filterBy')}} {{$t('message.driver').toLowerCase()}}</span>
                                      </a>
                                    </b-col>
                                  </b-row>

                                  <b-row>
                                    <b-collapse class="w-100 b-c-s-white" id="collapse-apponitee" v-model="shownAppointee">
                                      <b-container class="my-max-width ml-2 mr-2">
                                        <b-row align-h="center" align-v="center" class="text-center mt-2 mb-0">
                                          <b-form-group label-for="input-driver" class="flex-grow-1 mb-1">
                                            <model-list-select id="input-driver"
                                                               option-value="id"
                                                               :customText="getDriverOption"
                                                               :placeholder="allDrivers && allDrivers.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                                               v-model="driverSelected"
                                                               :list="allDrivers">
                                            </model-list-select>
                                          </b-form-group>
                                        </b-row>

                                        <b-row align-h="center">
                                          <div class="my-label" v-if="driverResigned">
                                            {{$tc('info.driverResigned', 1)}}
                                          </div>
                                        </b-row>
                                      </b-container>
                                    </b-collapse>
                                  </b-row>
                                </b-container>
                              </b-card>
                            </b-col>
                          </transition>
                        </b-row>

                        <b-row v-if="false">
                          <transition name="slide-left">
                            <b-col v-show="!realTime">
                              <b-card class="m-0 p-0 border-0 c-black b-c-s-white" no-body>
                                <b-container class="mw-100 m-0 p-0">
                                  <b-row :class="showContent(shownInstruments)">
                                    <b-col @click="shownInstruments = !shownInstruments" :class="`{{showContent(shownInstruments)}} p-0 hover-enabled`">
                                      <a class="vsm-link p-2">
                                        <i :class="shownInstruments ? 'fa fa-angle-down mb-3 mt-3 m-2' : 'fa fa-angle-left mb-3 mt-3 m-2'"></i>
                                        <span class="vsm-title">{{$t('message.filterBy')}} {{$t('message.instruments').toLowerCase()}}</span>
                                      </a>
                                    </b-col>
                                  </b-row>

                                  <b-row>
                                    <b-collapse class="w-100 b-c-s-white" id="collapse-instruments" v-model="shownInstruments">
                                      <b-container class="my-max-width ml-2 mr-2">
                                        <b-row align-h="center" align-v="center" class="text-center mt-2 mb-2">
                                          <b-col cols="auto">
                                            Area strumenti
                                          </b-col>
                                        </b-row>
                                      </b-container>
                                    </b-collapse>
                                  </b-row>
                                </b-container>
                              </b-card>
                            </b-col>
                          </transition>
                        </b-row>
                      </b-container>
                    </transition>
                  </b-col>
                </b-row>
              </b-container>
            </div>
          </div>
        </div>
      </div>

      <popup ref="popup" :position="position" v-on:redirect="redirect" v-show="position" :lang="lang" :$t="$tc" hideLabel="true" />

      <b-modal ref="reportModal" id="reportModal" :title="`${$tc('message.report', 1)} ${$tc('message.stop', 2).toLocaleLowerCase()}`" size="lg">
        <b-container>
          <b-row>
            <b-col cols="12" class="mb-2" v-if="reportMain.plateNumber">
              <h5 class="c-green mb-0 pb-0">{{ $tc('message.numberPlate', 1) }}</h5> {{ reportMain.plateNumber }}
            </b-col>

            <b-col cols="6" class="mb-2" v-if="reportMain.start">
              <h5 class="c-green mb-0 pb-0">{{ $tc('message.start', 1) }}</h5> {{ reportMain.start }}
            </b-col>

            <b-col cols="6" class="mb-2" v-if="reportMain.end">
              <h5 class="c-green mb-0 pb-0">{{ $tc('message.end', 1) }}</h5> {{ reportMain.end }}
            </b-col>

            <b-col cols="6" v-for="(stat, index) in reportDetails" class="mb-2" :key="index">
              <h5 class="c-green mb-0 pb-0">{{ stat.key }}</h5> {{ stat.value }}
            </b-col>
          </b-row>
        </b-container>

        <b-container>
          <h5 class="c-green mb-0 pb-1 mt-2">{{ $tc('message.details', 1) }}</h5>
          <standard-table ref="vehicleTable"
                          :items="reportStops"
                          :fields="reportStopsFields"

                          :row-search="{cols: 12,sm: 12,md: 12,lg: 12,xl: 12}"

                          :row-pagination="{cols: 12, sm: 12, md: 7, lg: 5, xl: 5}"
                          :row-between-pagination="{cols: 12, sm: 12, md: 1, lg: 1, xl: 1}"
                          :row-per-page="{cols: 12, sm: 12, md: 4, lg: 4, xl: 4}"
                          :row-after-per-page="{cols: 12, sm: 12, md: 12, lg: 2, xl: 2}"

                          :search-label-horizontal="false"
                          fullWidth="true"
                          :fixed="false"
                          noContainerPadding="true">

            <b-container slot="row-after-per-page" class="mw-100 p-0">
              <b-row>
                <b-col>
                  <b-button class="float-right mt-3 mt-md-0 mt-lg-0 mt-xl-0"
                            @click="downloadCustomExcel()"
                            id="excel-button">Excel
                  </b-button>
                </b-col>
              </b-row>
            </b-container>
          </standard-table>
        </b-container>

        <div slot="modal-footer" class="w-100 justify-content-end d-flex">
          <b-button class="b-c-green mr-3" id="excel-modal" @click="showReportModalOrDownload('xlsx')" v-if="false"> Excel </b-button>

          <b-button class="b-c-green mr-3" id="pdf-modal" @click="showReportModalOrDownload('pdf')" v-if="false">PDF </b-button>

          <b-button class="b-c-green" id="close-back-modal" @click="$refs.reportModal.hide()"> {{$tc('message.close', 1)}} </b-button>
        </div>
      </b-modal>
    </div>

    <b-container v-if="!motivationSent">
      <access-motivation @motivationSent="motivationDone()" ref="myMotivation"/>
    </b-container>
  </div>
</template>

<script>
import Vue from 'vue'
import { DateTime } from 'luxon'
import { find, cloneDeep, first, orderBy, trim, split, isEqual, sortBy, filter, capitalize, isNil } from 'lodash'
import logKeys from '@/plugins/log-keys'
import { positionService } from '@/components/vue-plugins/Map/positionService'
import axios from 'axios'

export default {
  name: 'InteractiveMap',
  watch: {
    vehicleSelected (val) {
      if (val) {
        this.driverSelected = ''
        this.logData()
      }
    },
    realTime (newVal) {
      if (newVal) {
        this.refreshCountDown = this.myRefreshTime / 1000
        this.myDate = DateTime.local().toISO()
      } else {
        this.changeDate(null, null, null, true)
      }
      this.updateAllVehicles(newVal)
      this.updateDrivers(newVal)
      this.logData()
    },
    myDate (newVal) {
      if (!this.realTime || !this.delayedStart || !this.delayedEnd) {
        this.delayedStart = DateTime.fromISO(newVal).set({ minute: 0, second: 0, millisecond: 0 }).toMillis()
        this.logData()
      }
    },
    delayedStart (newVal, oldVal) {
      const hourInMilliseconds = 3600 * 1000
      const halfSlide = this.slideData && this.slideData.length !== 0 ? (this.slideData / 2) - 1 : 2
      const hourDiff = (newVal - (oldVal || (newVal - (halfSlide * hourInMilliseconds)))) / hourInMilliseconds
      const oldHour = this.hourRangeSelector ? this.getHourNumber(this.hourRangeSelector) : DateTime.fromMillis(newVal).plus({ hour: 1 }).hour
      const newHour = DateTime.local().set({ hour: oldHour }).plus({ hour: hourDiff }).hour
      this.hourRangeSelector = `${newHour < 10 ? '0' + newHour : newHour}:00`
      this.checkHourRangeSelectorNewVal(`${newHour < 10 ? '0' + newHour : newHour}:00`)
    },
    delayedEnd () {
      const now = DateTime.local().ts
      const millisecondsToDelay = 1500
      this.lastEdit = now + millisecondsToDelay
      this.addTimer(millisecondsToDelay)
    },
    hourRangeSelector (newVal) {
      this.checkHourRangeSelectorNewVal(newVal)
    },
    driverSelected (newVal) {
      if (newVal) {
        this.vehicleSelected = ''
        this.logData()
      }
      const foundedDriver = find(this.allDrivers, obj => obj.id === newVal)
      if (foundedDriver && foundedDriver.resignDate) {
        this.driverResigned = true
      } else {
        this.driverResigned = null
      }
    }
  },
  data () {
    const token = Vue.getLocalStorage('session').token
    const lang = Vue.getLocalStorage('lang')
    const BASE_URL = Vue.getBaseUrl()
    const refreshInMillis = 60000
    const defaultStart = DateTime.local().set({ minute: 0, second: 0, millisecond: 0 })
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
    const config = this.$route.meta.config

    return {
      config,
      token,
      lang,
      DateTime,
      isSafari,
      url: BASE_URL,
      motivationSent: false,
      // other
      allVehiclePositions: [],
      allVehicles: [],
      originalVehicles: [],
      allDrivers: [],
      originalDrivers: [],
      allTrackers: [],
      vehicleSelected: null,
      driverSelected: null,
      myRefreshTime: refreshInMillis,
      shown: true,
      realTime: true,
      shownVehicle: true,
      shownAppointee: false,
      shownInstruments: false,
      window: {
        width: 0,
        height: 0
      },
      isMobile: false,
      myDate: DateTime.local().toISO(),
      refreshCountDown: (refreshInMillis / 1000) - 1,
      delayedStart: defaultStart.plus({ hours: -3 }).toMillis(),
      delayedEnd: defaultStart.toMillis(),
      hourRangeSelector: `${defaultStart.hour < 10 ? '0' + defaultStart.hour : defaultStart.hour}:00`,
      slideData: [],
      position: null,
      filterStart: defaultStart.plus({ hours: -3 }).toMillis(),
      filterEnd: defaultStart.toMillis(),
      showNoOBU: false,
      driverResigned: null,
      lastEdit: null,
      loadedItemsTimeout: null,
      reportStops: [],
      reportStopsFields: {},
      reportDetails: {},
      reportMain: {},
      lastLog: null
    }
  },
  beforeMount () {
    this.updateRefreshCountDown()
    this.handleResize()
  },
  mounted () {
    this.$root.$on('change-lang', (val) => {
      this.lang = val
    })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    initCancelToken () {
      if (this.cancelRequest) {
        this.cancelRequest()
      }
      var CancelToken = axios.CancelToken
      let cancelFunction
      var ct = new CancelToken(function executor (c) {
        // An executor function receives a cancel function as a parameter
        cancelFunction = c
      })
      this.cancelRequest = cancelFunction
      return ct
    },
    addTimer (timer) {
      setTimeout(() => {
        const now = DateTime.local().ts
        const timerExpired = now - this.lastEdit >= 0
        if (timerExpired) {
          this.$root.$emit('activeLoader', true)
          this.filterStart = cloneDeep(this.delayedStart)
          this.filterEnd = cloneDeep(this.delayedEnd)
          this.logData()
        }
      }, timer)
    },
    fetchData () {
      this.getOptions().then(() => this.getVehicles().then(() => {}))
    },
    getOptions () {
      const axiosArray = []
      axiosArray.push(this.getAllDrivers())
      axiosArray.push(this.getAllTrackers())
      return Vue.myAll(axiosArray).then(r => r)
    },
    getAllDrivers () {
      return Vue.myGet(this, '/drivers', 'drivers').then((drivers) => {
        const editedDrivers = [{ editedName: this.$t('message.selectOption'), text: this.$t('message.selectOption'), id: '', keyCode: true }]
        const orderedItems = orderBy(drivers, ['surname', 'name'])
        orderedItems.forEach(driver => {
          const nameAlreadyExist = find(editedDrivers, obj => trim(obj.surname) === trim(driver.surname) && trim(obj.name) === trim(driver.name))
          const editedDriver = driver
          editedDriver.editedName = `${driver.surname} ${driver.name} - ${driver.taxCode}`
          editedDrivers.push(editedDriver)
        })
        this.originalDrivers = editedDrivers
        this.updateDrivers(true)
        this.driverSelected = ''
        return editedDrivers
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
        return false
      })
    },
    getAllTrackers () {
      return Vue.myGet(this, '/trackers', 'trackers').then((trackers) => {
        this.allTrackers = trackers
        return trackers
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
        return false
      })
    },
    getVehicles () {
      return Vue.myGet(this, '/vehicles', 'vehicles').then((vehicles) => {
        this.originalVehicles = [{ id: '', imei: true, plateNumber: vehicles && vehicles.length !== 0 ? this.$t('message.selectOption') : this.$t('message.noOption') }]
        const orderedItems = orderBy(vehicles, 'plateNumber')
        orderedItems.forEach((vehicle) => {
          this.originalVehicles.push(vehicle)
        })
        this.updateAllVehicles(this.realTime)
        return vehicles
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
        return false
      })
    },
    updateAllVehicles (realTime) {
      const originalItems = cloneDeep(this.originalVehicles)
      const editedItems = []
      originalItems.forEach(item => {
        if (item.imei && !item.resignDate) {
          editedItems.push(item)
        }
      })
      const hasItems = editedItems.length !== 0 && editedItems.length !== 1
      this.allVehicles = editedItems
      this.vehicleSelected = realTime ? '' : (hasItems ? editedItems[1].id : null)
    },
    updateDrivers (realtime) {
      const originalItems = cloneDeep(this.originalDrivers)
      const editedItems = []
      if (!realtime) {
        this.allDrivers = originalItems
      } else {
        originalItems.forEach(item => {
          if (item.keyCode) {
            editedItems.push(item)
          }
        })
        this.allDrivers = editedItems
      }
      this.driverSelected = ''
    },
    clickPosition (position, marker) {
      if (position) {
        const foundedVehicle = find(this.allVehicles, obj => obj.id === position.properties.vehicleId)
        const foundedDriver = find(this.allDrivers, obj => obj && obj.id === position.properties.driverId)
        const foundedTracker = find(this.allTrackers, obj => obj.imei === position.properties.imei)
        var returnResponse = {
          vehicle: foundedVehicle || null,
          driver: foundedDriver || null,
          tracker: foundedTracker || null
        }
        const ct = this.initCancelToken()
        positionService.getAssetsPositions(ct, this.url, this.token, position.properties.imei, position.properties.ts)
          .then(async (assetsPositions) => {
            await Vue.myGet(this, '/enums/asset_type', 'data').then(async (assetTypes) => {
              await Vue.myGet(this, '/assets', 'assets').then((assets) => {
                const items = sortBy(filter(assets, obj => obj.name), o => capitalize(o.name))
                items.forEach((item) => {
                  item.typeString = !isNil(find(assetTypes, option => option.id === item.type))
                    ? find(assetTypes, option => option.id === item.type).descr : ''
                })
                assetsPositions.forEach((item) => {
                  item.typeString = !isNil(find(assets, asset => asset.id === item.id)) ? find(assets, asset => asset.id === item.id).typeString : ''
                })
                position.blescans = assetsPositions
                returnResponse.extraData = position
                this.position = returnResponse
                if (this.position && marker) {
                  marker.bindPopup(this.$refs.popup.$el, {
                    maxWidth: 310,
                    minWidth: 200
                  }).openPopup()
                }
              }).catch(error => {
                Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
              })
            }).catch(error => {
              Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
            })
          })
          .catch(error => {
            this.mapError(error)
          })
      }
    },
    redirect (link) {
      if (link.href) this.$router.push(link.href)
    },
    mapError (error) {
      // eslint-disable no-console
      console.error(error)
      this.$root.$emit('activeLoader', false)
    },
    handleResize () {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight
      this.isMobile = window.innerWidth < 767
    },
    showContent (contentToShow) {
      return contentToShow ? 'b-c-l-gray c-black' : 'b-c-l-gray c-black'
    },
    showReportModalOrDownload (format) {
      const vehicleSelected = this.vehicleSelected
      // const driverSelected = this.driverSelected
      const tsStart = this.filterStart / 1000
      const tsEnd = this.filterEnd / 1000
      let url = 'report'

      if (vehicleSelected) url = `${url}?vehicle=${vehicleSelected}`
      // if (driverSelected) url = `${url}${vehicleSelected ? '&' : '?'}driver=${driverSelected}`

      if (!format) format = 'json'

      url = `${url}&start=${tsStart}`
      url = `${url}&end=${tsEnd}`
      url = `${url}&format=${format}`

      this.$root.$emit('activeLoader', true)

      if (format === 'json') {
        this.reportStops = []
        this.getReportStopsFields()

        Vue.myGet(this, url, 'report').then(positions => {
          this.reportStops = positions.stopList
          this.reportDetails = positions.stats
          this.reportMain = {
            plateNumber: positions.plateNumber,
            start: positions.start,
            end: positions.end
          }
          this.$root.$emit('activeLoader', false)
          this.$refs.reportModal.show()
        }).catch(error => {
          this.$root.$emit('activeLoader', false)
          Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
        })
      } else {
        Vue.myGet(this, url, 'linkFile').then(obj => {
          const plateNumber = find(this.allVehicles, o => o.id === vehicleSelected).plateNumber
          const start = DateTime.fromMillis(tsStart * 1000).toFormat('dd-MM-yyyy')
          const end = DateTime.fromMillis(tsEnd * 1000).toFormat('dd-MM-yyyy')

          Vue.downloadURI(obj, `Report-${plateNumber}-${start}-${end}.${format}`)
          this.$root.$emit('activeLoader', false)
        }).catch(error => {
          this.$root.$emit('activeLoader', false)
          Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
        })
      }
    },
    downloadCustomExcel () {
      const plateNumber = find(this.allVehicles, o => o.id === this.vehicleSelected).plateNumber
      const fileName = `${plateNumber}`
      const start = DateTime.fromMillis(this.filterStart).toFormat('dd-MM-yyyy')
      const end = DateTime.fromMillis(this.filterEnd).toFormat('dd-MM-yyyy')
      const colName = []

      const body = [
        [this.$tc('message.numberPlate', 1), plateNumber],
        [this.$tc('message.start', 1), start, '', this.$tc('message.end', 1), end]
      ]

      this.reportDetails.forEach(detail => {
        body.push([detail.key, detail.value])
      })

      body.push([])

      this.reportStopsFields.forEach(field => {
        colName.push(field.label)
      })
      body.push(colName)

      this.reportStops.forEach(position => {
        const raw = []
        this.reportStopsFields.forEach(field => {
          raw.push(position[field.key])
        })
        body.push(raw)
      })

      Vue.excelFromCustomMatrix(body, fileName)
    },
    getReportStopsFields () {
      this.reportStopsFields = [
        { key: 'driver', label: this.$tc('message.driver', 1), sortable: true, sortDirection: 'desc' },
        { key: 'startDate', label: this.$tc('message.start', 1), sortable: true, sortDirection: 'desc' },
        { key: 'duration', label: `${this.$tc('message.duration', 1)} ${this.$tc('message.stop', 1).toLocaleLowerCase()}` },
        { key: 'address', label: this.$tc('message.address', 1), sortable: true, sortDirection: 'desc' }
      ]
    },
    newDate () {
      setTimeout(() => {
        if (this.realTime) {
          this.myDate = DateTime.local().toISO()
        }
        this.newDate()
      }, this.isSafari ? 60000 : 999)
    },
    updateRefreshCountDown () {
      setTimeout(() => {
        const path = this.$route.path
        const map = this.$refs.staticMap
        if (this.refreshCountDown === 0 && this.realTime && map) map.refresh()
        if (this.realTime) this.$root.$emit('activeLoader', false)
        this.refreshCountDown = this.refreshCountDown !== 0 ? this.refreshCountDown - 1 : (this.myRefreshTime / 1000) - 1
        if (path === '/map' || path === '/home') {
          this.updateRefreshCountDown()
        }
      }, this.isSafari ? 60000 : 999)
    },
    changeDate (selector, period, addition, reset) {
      if (reset) {
        const defaultStart = DateTime.local().set({ minute: 0, second: 0, millisecond: 0 })
        this.myDate = defaultStart.plus({ hours: -3 }).toISO()
        this.delayedStart = defaultStart.plus({ hours: -3 }).toMillis()
        this.delayedEnd = defaultStart.toMillis()
        this.hourRangeSelector = `${defaultStart.hour < 10 ? '0' + defaultStart.hour : defaultStart.hour}:00`
      } else {
        this[selector] = DateTime.fromISO(this[selector]).set({ minute: 0, second: 0, millisecond: 0 }).plus({ [period]: addition }).toISO()
      }
    },
    checkIfCouldBeMore (start, period, addition) {
      const nowDate = DateTime.local().set({ minutes: 0, seconds: 0, milliseconds: 0 })
      const currentValueStart = DateTime.fromISO(this[start])
      const nextValueStart = currentValueStart.plus({ [period]: addition })
      const nextValueEnd = currentValueStart.set({ hours: this.getHourNumber(this.hourRangeSelector) }).plus({ [period]: addition })
      const maxValueStart = nowDate.plus({ hours: -3 })
      const maxValueEnd = nowDate.plus({ hours: 1 })

      const addADayToNewDateEnd = nextValueEnd.hour < currentValueStart.hour
      if (addADayToNewDateEnd) nextValueEnd.plus({ days: 1 })

      return nextValueStart <= maxValueStart && nextValueEnd <= maxValueEnd
    },
    reachedTop (selector) {
      const nowDate = DateTime.local().set({ minutes: 0, seconds: 0, milliseconds: 0 })
      const currentVal = DateTime.fromISO(this[selector]).set({ minute: 0, second: 0, millisecond: 0 })
      const maxValue = nowDate.plus({ hours: -3 })
      return currentVal >= maxValue ? 'hover-not-allowed c-ls-gray' : 'hover-enabled h-c-blue'
    },
    getSlideData () {
      const startDate = DateTime.fromMillis(this.delayedStart)
      const now = DateTime.local()
      const result = []
      if (this.delayedStart) {
        for (let x = 1; x < 13; x++) {
          const newDate = startDate.plus({ hours: x })
          const maxDate = now.plus({ hours: 1 })

          if (newDate < maxDate) {
            result.push(`${newDate.hour < 10 ? '0' + newDate.hour : newDate.hour}:00`)
          }
        }
      }
      this.slideData = result
      return result
    },
    getVehicleOption (e) {
      return `${e.plateNumber}${e.type && e.type.brand ? ' - ' + e.type.brand : ''}${e.type && e.type.model ? ' - ' + e.type.model : ''}`
    },
    getDriverOption (e) {
      return e.editedName
    },
    getHourNumber (val) {
      return parseInt(first(split(val, ':')))
    },
    loadedHistoryPosition () {
      this.setLoadedItemsTimeout()
    },
    setLoadedItemsTimeout () {
      this.loadedItemsTimeout = DateTime.local().ts + 2500
      this.$root.$emit('activeLoader', false)
      setTimeout(() => {
        const now = DateTime.local().ts
        const positions = this.$refs.staticMap && this.$refs.staticMap.historyPositions && this.$refs.staticMap.historyPositions.length
        const timerExpired = now - this.loadedItemsTimeout >= 0
        if (timerExpired) {
          if (positions === 0 && !this.realTime) Vue.info(this, this.$tc('info.emptyPositions'))
        }
      }, 2500)
    },
    checkHourRangeSelectorNewVal (newVal) {
      const hourEnd = newVal ? this.getHourNumber(newVal) : DateTime.fromMillis(this.delayedStart).plus({ hour: 1 }).hour
      const hourStart = DateTime.fromMillis(this.delayedStart).hour
      const hourDiff = hourEnd - hourStart
      let newEnd = null
      if (hourDiff > 0) {
        newEnd = DateTime.fromMillis(this.delayedStart).set({ hour: hourEnd }).toMillis()
      } else {
        newEnd = DateTime.fromMillis(this.delayedStart).set({ hour: hourEnd }).plus({ days: 1 }).toMillis()
      }
      this.delayedEnd = newEnd
    },
    // motivation methods
    motivationDone () {
      this.motivationSent = true
      this.$refs.myMotivation.reset()

      this.fetchData()
      window.addEventListener('resize', this.handleResize)
      this.newDate()

      Vue.success(this, `${this.$tc('message.motivation')} ${this.$tc('message.added', 2).toLowerCase()}`)
    },
    // log functions
    logData () {
      const realTime = this.realTime ? this.$tc('message.realTime', 1) : this.$tc('message.travel', 1)
      const start = this.filterStart
      const end = this.filterEnd
      const vehicle = this.vehicleSelected
      const driver = this.driverSelected
      const format = 'dd-MM-yyyy HH:mm:ss'
      const logObj = Vue.getLogObj(this, 'get', '/map')

      logObj.data.details = []

      logObj.data.details.push({ text: 'message.type', option: 1, value: realTime })
      if (start) logObj.data.details.push({ text: 'message.start', option: 1, value: DateTime.fromMillis(start).toFormat(format) })
      if (end) logObj.data.details.push({ text: 'message.end', option: 1, value: DateTime.fromMillis(end).toFormat(format) })
      if (vehicle) logObj.data.details.push({ text: 'message.vehicle', option: 1, value: vehicle, key: logKeys.vehicle })
      if (driver) logObj.data.details.push({ text: 'message.driver', option: 1, value: driver, key: logKeys.driver })

      if (this.checkIfLogsAreEqual(logObj, this.lastLog)) {
        Vue.myLogPost(logObj)
        this.lastLog = logObj
      }
    },
    checkIfLogsAreEqual (o, lastO) {
      if (!lastO) return true
      return !isEqual(o.data, lastO.data)
    }
  }
}
</script>

<style scoped>
.main-container {
  display: flex;
  flex-flow: column;
}

.counter-container {}

.all-content {
  display: flex;
  align-items: stretch;
  flex-grow: 1;
}

.view-container {
  width: 100%;
  display: flex;
  align-items: stretch;
}

.map-container {
  display: flex;
  flex-grow: 1;
}

.my-sidebar-container {
  display: flex;
}

.my-map {
  width: 100%;
  display: flex !important;
}

.my-map > div {
  flex: 1 1 auto;
  display: flex;
  height: auto;
}

.my-sidebar {
  display: flex;
  flex-flow: column;
  flex-grow: 1;
}

.my-max-width {
  max-width: 350px !important
}

.my-border-radius {
  border-radius: 20px;
}

.slide-left-enter-active {
  transition: all 2s ease;
}
.slide-left-enter, .slide-left-leave-to {
  transform: translateX(20px);
  opacity: 0;
}

.slide-right-enter-active {
  transition: all 2s ease;
}
.slide-right-enter, .slide-right-leave-to {
  transform: translateX(-20px);
  opacity: 0;
}

.scroll-fade-enter-active {
  transition: all 1s ease;
}
.scroll-fade-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.scroll-fade-enter, .scroll-fade-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}
</style>
